"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event2ToJSON = exports.Event2FromJSONTyped = exports.Event2FromJSON = exports.instanceOfEvent2 = void 0;
var runtime_1 = require("../runtime");
var EventType_1 = require("./EventType");
/**
 * Check if a given object implements the Event2 interface.
 */
function instanceOfEvent2(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfEvent2 = instanceOfEvent2;
function Event2FromJSON(json) {
    return Event2FromJSONTyped(json, false);
}
exports.Event2FromJSON = Event2FromJSON;
function Event2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, EventType_1.EventTypeFromJSON)(json['type']),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'lastActivityAt': !(0, runtime_1.exists)(json, 'last_activity_at') ? undefined : (new Date(json['last_activity_at'])),
    };
}
exports.Event2FromJSONTyped = Event2FromJSONTyped;
function Event2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, EventType_1.EventTypeToJSON)(value.type),
    };
}
exports.Event2ToJSON = Event2ToJSON;
